// menuData.js
export const marketplaceMenu = [
    { id: '', label: 'Healthcare' },
    { id: '119', label: 'Music' },
    { id: '120', label: 'Cinema' },
];

export const verticalsMenu = [
    { href: '/music', label: 'Music' },
    { href: '/cinema', label: 'Cinema' },
    { href: '/venues', label: 'Attractions' },
    { href: '/advocacy', label: 'Advocacy' },
];

export const informationMenu = [
    { href: '/about_company', label: 'The Company' },
    { href: '/about_platform', label: 'The Platform' },
    { href: '/about_card', label: 'The Card' },
    { href: '/privacy_policy', label: 'Privacy Policy' },
    { href: '/terms_conditions', label: 'Terms & Conditions' },
    { href: '/contact_us', label: 'Contact Us' },
];
